module.exports = __webpack_public_path__ + "static/media/2.e32b2933.png";